import { useState, useEffect } from 'react';
import { constructHeadline } from '../service/CreatePromotionService';

export const usePromotionPreview = ({
  data,
  promotionData,
  flipValue,
  selectedConjunction,
  disableDRAFTBtn,
  disableUPDATEBtn,
  selectedStores,
}) => {
  const [headline, setHeadline] = useState('[Please Select an HEADLINE]');
  const [disclaimerData, setDisclaimerData] = useState(null);
  const [notes, setNotes] = useState(null);

  // Dynamically generate the headline based on the promotion data
  useEffect(() => {
    setHeadline(constructHeadline(data, flipValue, selectedConjunction));
    setDisclaimerData(data?.disclaimer || {});
    setNotes(data?.notes || '');
  }, [data, flipValue, selectedConjunction]);

  // Button disabled conditions
  const isHeadlineEmpty = (headline) => {
    return headline === null || headline.length === 0 || headline === '[Please Select an HEADLINE]';
  };

  const isButtonDisabled = (buttonType) => {
    switch (buttonType) {
      case 'create':
        return (
          selectedStores.length === 0 || !promotionData?.start_date || !promotionData?.end_date
        );
      case 'update':
        return disableUPDATEBtn || isHeadlineEmpty(headline);
      case 'publish':
        return isHeadlineEmpty(headline);
      case 'draft':
        return disableDRAFTBtn || isHeadlineEmpty(headline);
      default:
        return true;
    }
  };

  return {
    headline,
    disclaimerData,
    notes,
    isButtonDisabled,
  };
};
